<app-loading *ngIf="contentReady"></app-loading>
<div class="addresses-container bg-light">
    <div class="row d-flex justify-content-center align-items-center" style="margin-bottom: 70px;">

        <div>
            <div class="col-12">
                <img style="width: 200px;margin: 0 auto;" src="/assets/e-commerce/icons/62.webp" alt="" />
                <h2>{{"welcometext" | transloco}}</h2>

                <p>{{"aboutusbody" | transloco}}</p>

            </div>



        </div>
    </div>